import * as Styled from './styles'

export default function TitleMedium({ children }) {
  return <Styled.TitleMedium>{children}</Styled.TitleMedium>
}
